import { Divider, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { createSpecificAppDetailsLink } from '../../common/routing/app-navigator';
import { InventoryTooltipItems } from '../inventory-types';

const InventoryTooltipContent: FC<
  React.PropsWithChildren<InventoryTooltipContentProps>
> = ({ apps }) => {
  const { classes } = useStyles();
  return (
    <>
      <div className={classes.inventoryTooltipTitle}>
        <Typography variant='body1' color='text.primary'>
          TOP {apps.length} APPS BY PRIORITY
        </Typography>
      </div>
      <Divider />
      <ol className={classes.appList}>
        {apps.map((app, i) => (
          <RouterLink
            to={createSpecificAppDetailsLink(app.appName)}
            className={classes.appLink}
            key={app.appName}>
            <Typography
              component='li'
              color='text.secondary'
              lineHeight={2}
              variant='body2'
              overflow='hidden'
              textOverflow='ellipsis'
              whiteSpace='nowrap'>
              {app.appName.toUpperCase()}
            </Typography>
          </RouterLink>
        ))}
      </ol>
    </>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  inventoryTooltipTitle: {
    paddingBlock: theme.spacing(1.5),
    paddingInline: theme.spacing(2),
  },
  appList: {
    paddingBlock: theme.spacing(0.5),
    paddingInline: theme.spacing(4),
  },
  appLink: {
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.text.secondary,
    },
  },
}));

export interface InventoryTooltipContentProps {
  apps: InventoryTooltipItems[];
}

export default InventoryTooltipContent;
